import * as React from 'react';
import { CashbackConfig } from '../../../http/protocol';
import '../styles/CashbackConfig.scss';

interface Props {
  cashbackConfig?: CashbackConfig;
  onModeChange: (excluded: boolean) => void;
}

export const IncludeExcludeModeSelector: React.FC<Props> = ({ 
  cashbackConfig, 
  onModeChange 
}) => {
  const isExcluded = cashbackConfig?.excluded ?? false;

  const handleModeChange = (excluded: boolean) => {
    onModeChange(excluded);
  };

  const handleRadioChange = (excluded: boolean) => (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    handleModeChange(excluded);
  };

  const handleCardClick = (excluded: boolean) => () => {
    handleModeChange(excluded);
  };

  return (
    <div className="row mode-selection-row">
      <div className="col-sm-12">
        <div className="form-group">
          <div className="col-sm-12">
            <div className="row">
              <div className="col-sm-6">
                <div 
                  className={`mode-option ${!isExcluded ? 'mode-selected' : 'mode-unselected'}`}
                  onClick={handleCardClick(false)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleModeChange(false);
                    }
                  }}
                  aria-label="Select Include Mode"
                >
                  <div className="mode-header">
                    <input 
                      type="radio" 
                      name="excludeMode" 
                      checked={!isExcluded}
                      onChange={handleRadioChange(false)}
                      aria-label="Include Mode"
                    />
                    <i className="fa fa-check text-success" style={{marginLeft: '10px'}}></i>
                    <span className="mode-title">Include Mode</span>
                  </div>
                  <div className="mode-description">
                    Only items in the list will be allowed.
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
                <div 
                  className={`mode-option ${isExcluded ? 'mode-selected' : 'mode-unselected'}`}
                  onClick={handleCardClick(true)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleModeChange(true);
                    }
                  }}
                  aria-label="Select Exclude Mode"
                >
                  <div className="mode-header">
                    <input 
                      type="radio" 
                      name="excludeMode" 
                      checked={isExcluded}
                      onChange={handleRadioChange(true)}
                      aria-label="Exclude Mode"
                    />
                    <i className="fa fa-times text-danger" style={{marginLeft: '10px'}}></i>
                    <span className="mode-title">Exclude Mode</span>
                  </div>
                  <div className="mode-description">
                    Items in the list will be blocked.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
